import { apiOrigin } from './site';
// Image URL helpers shared across the ProductPicker / Designer / ProposalView
// components.
//
// Backward-compat: iteration_36 briefly saved item image_urls as
// `/api/img-proxy?url=<encoded>` — a relative URL that only worked when the
// frontend and backend shared the same origin. In production the frontend is
// often served from a different origin (custom domain / preview host) so
// those relative URLs 404. `unwrapImg` extracts the underlying raw CDN URL
// from any legacy proxied value so a plain <img src> works from any origin.

export const unwrapImg = (u) => {
  if (!u || typeof u !== 'string') return u;
  if (u.startsWith('/api/img-proxy?url=')) {
    try {
      return decodeURIComponent(u.split('url=')[1] || '');
    } catch {
      return u;
    }
  }
  const m = u.match(/https?:\/\/[^/]+\/api\/img-proxy\?url=(.+)$/);
  if (m) {
    try {
      return decodeURIComponent(m[1]);
    } catch {
      return u;
    }
  }
  return u;
};

/**
 * Wrap a raw CDN URL through the backend's CORS proxy so it can be drawn onto
 * an HTML canvas without tainting. Uses REACT_APP_BACKEND_URL so the request
 * always hits the correct backend regardless of which origin currently serves
 * the frontend.
 *
 * Only use this for canvas rendering — regular <img> tags should use the raw
 * URL (via unwrapImg) directly.
 */
export const proxyImg = (rawUrl) => {
  const clean = unwrapImg(rawUrl);
  if (!clean || typeof clean !== 'string') return clean;
  if (!clean.startsWith('http')) return clean; // already relative
  const base = apiOrigin();
  if (!base) {
    // Fail loudly in dev so a missing env doesn't cause silent tainted-canvas
    // errors at runtime.
    // eslint-disable-next-line no-console
    console.warn('proxyImg: REACT_APP_BACKEND_URL is not set; canvas may taint');
    return clean;
  }
  return `${base}/api/img-proxy?url=${encodeURIComponent(clean)}`;
};
